import type { FormErrors } from 'redux-form';

import type { ShortenUrlRequestModel } from 'ab-requestModels/shortenUrl.requestModel';

import { URL_REGEX } from '@acceligentllc/shared/constants/regex';

export function validate(values: ShortenUrlRequestModel): FormErrors<ShortenUrlRequestModel> {
	const errors: FormErrors<ShortenUrlRequestModel> = {};

	if (!values.url) {
		errors.url = 'Url is required';
	} else if (!URL_REGEX.test(values.url)) {
		errors.url = 'Url is invalid';
	}

	return errors;
}
